import "./styles/main.scss";
// import "./favicon";
import "./partyLimiter";

import Macy from "macy";

const macyInstance = Macy({
  container: document.querySelector(".sections"),
  columns: 5,
  breakAt: {
    1500: 4,
    1250: 3,
    900: 2,
    550: 1,
  },
});

window.macy = macyInstance;

window.addEventListener("resize", () => {
  macyInstance.recalculate(true);
});

macyInstance.runOnImageLoad(function () {
  macyInstance.recalculate(true);
}, true);
